export default "__VITE_ASSET__DEMgjV9$__"